import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';
import styles from './InputFields.scss';

export default function InputGenerator(type) {
    class InputField extends Component {
        static displayName = displayName('Forms/InputFields');

        static propTypes = {
            type: PropTypes.oneOf(['text', 'password', 'number']),
            focused: PropTypes.bool,
            width: PropTypes.string,
            status: PropTypes.oneOf(['', 'success', 'error', 'disabled']).isRequired,
            initialValue: PropTypes.string,
            value: PropTypes.any,
            onChange: PropTypes.func,
            placeholder: PropTypes.string,
        };

        static defaultProps = {
            status: '',
            type: 'text',
            width: '',
            focused: false,
            initialValue: '',
            value: '',
            onChange: () => {},
            placeholder: '',
        };

        componentDidMount() {
            if (this.props.focused) {
                this.moveCarretAtEnd();
            }
        }

        get inputProps() {
            const { status, focused, width, value, placeholder } = this.props;

            return {
                ...omit(this.props, [
                    'disabled',
                    'focused',
                    'status',
                    'styles',
                    'initialValue',
                    'autofill',
                    'onUpdate',
                    'valid',
                    'invalid',
                    'dirty',
                    'pristine',
                    'error',
                    'active',
                    'touched',
                    'visited',
                    'autofilled',
                    'toggleInArray',
                    'toggle',
                    'change',
                ]),
                autoFocus: focused || false,
                disabled: status === 'disabled',
                value: value || '',
                onChange: this.props.onChange,
                placeholder,
                width,
            };
        }

        moveCarretAtEnd = () => {
            this.inputField.selectionStart = this.inputField.value.length;
            this.inputField.selectionEnd = this.inputField.value.length;
        };

        render() {
            const { status, width } = this.props;

            let className = `input-field${type ? `-${type}` : ''}`;

            if (status) {
                className += `-${status}`;
            }

            return (
                <div className={styles['form-field']} style={{ width }} data-input-field>
                    <input
                        className={styles[className]}
                        ref={(inputField) => {
                            this.inputField = inputField;
                        }}
                        {...this.inputProps}
                    />
                    {status === 'success' && <span className={styles['success-icon']} />}
                </div>
            );
        }
    }

    return InputField;
}
